/**
 * @generated SignedSource<<142a40b892f826dc2f046cf3f28981c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccessModal_Query$variables = {
  id: string;
};
export type AccessModal_Query$data = {
  readonly node: {
    readonly __typename?: string;
    readonly hasAuditLog?: string;
    readonly id: string;
    readonly members?: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member">;
    }>;
    readonly name?: string;
    readonly " $fragmentSpreads": FragmentRefs<"PermissionRules_node" | "SpaceItemAccessDetails_node" | "VaultAccessDetails_node" | "VaultAvatar_vault" | "VaultItemAccessDetails_node" | "useNodeSecurity_node">;
  } | null;
};
export type AccessModal_Query = {
  response: AccessModal_Query$data;
  variables: AccessModal_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "hasAuditLog",
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "HasAuditLogInterface",
  "abstractKey": "__isHasAuditLogInterface"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canUpdate",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = [
  (v2/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "ownershipSpace",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roles",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowedRoles",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberConnection",
    "kind": "LinkedField",
    "name": "allowedMembers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MemberEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Member",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canModifyOwners",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v17 = [
  (v3/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mimeType",
        "storageKey": null
      }
    ],
    "type": "File",
    "abstractKey": null
  },
  (v16/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v9/*: any*/),
    "type": "PendingFile",
    "abstractKey": null
  }
],
v18 = [
  (v11/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = [
  (v2/*: any*/),
  (v4/*: any*/),
  (v12/*: any*/),
  (v19/*: any*/),
  (v13/*: any*/)
],
v21 = [
  (v4/*: any*/)
],
v22 = [
  (v2/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccessModal_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PermissionRules_node"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useNodeSecurity_node"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VaultItemAccessDetails_node"
              }
            ],
            "type": "VaultItem",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SpaceItemAccessDetails_node"
              }
            ],
            "type": "HasOwnerPermissionsInterface",
            "abstractKey": "__isHasOwnerPermissionsInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Member",
                "kind": "LinkedField",
                "name": "members",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "UserAvatar_member"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VaultAvatar_vault"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VaultAccessDetails_node"
              }
            ],
            "type": "Vault",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccessModal_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "isEvent",
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v8/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CalendarEventPermissionConfig",
                "kind": "LinkedField",
                "name": "permissionConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PermissionRule",
                    "kind": "LinkedField",
                    "name": "canCreateFolderInRoot",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PermissionRule",
                    "kind": "LinkedField",
                    "name": "canCreateItemInRoot",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Event",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "isFolder",
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v15/*: any*/),
              (v10/*: any*/),
              {
                "alias": "folderPermissions",
                "args": null,
                "concreteType": "FolderNodePermissionConfig",
                "kind": "LinkedField",
                "name": "permissionConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PermissionRule",
                    "kind": "LinkedField",
                    "name": "canCreateFolderIn",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PermissionRule",
                    "kind": "LinkedField",
                    "name": "canCreateItemIn",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Folder",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorizationResult",
                "kind": "LinkedField",
                "name": "canUpdateSecurity",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preventDownload",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasWatermark",
                "storageKey": null
              }
            ],
            "type": "HasNodeSecurityInterface",
            "abstractKey": "__isHasNodeSecurityInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "folderItemContent",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": null
              }
            ],
            "type": "FolderItem",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "vaultItemContent",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VaultUploadGroup",
                "kind": "LinkedField",
                "name": "uploadGroup",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "publisher",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DateTime",
                    "kind": "LinkedField",
                    "name": "publishedAt",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "utcDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "utcTime",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "VaultItem",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "draftVaultItemContent",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": null
              }
            ],
            "type": "VaultDraftItem",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OwnershipConnection",
                        "kind": "LinkedField",
                        "name": "ownerships",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OwnershipEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Ownership",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Member",
                                    "kind": "LinkedField",
                                    "name": "member",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v4/*: any*/),
                                      (v12/*: any*/),
                                      (v19/*: any*/),
                                      (v13/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "status",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OwnableConnection",
                                    "kind": "LinkedField",
                                    "name": "ownerOf",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OwnableEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v21/*: any*/),
                                                "type": "Space",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v21/*: any*/),
                                                "type": "Event",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v21/*: any*/),
                                                "type": "Folder",
                                                "abstractKey": null
                                              },
                                              (v16/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "explicitOwner",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OwnableConnection",
                        "kind": "LinkedField",
                        "name": "ownershipPath",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OwnableEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v2/*: any*/),
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "icon",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v21/*: any*/),
                                            "type": "NamedIcon",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Color",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "light",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "dark",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Space",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v22/*: any*/),
                                    "type": "Event",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v22/*: any*/),
                                    "type": "Folder",
                                    "abstractKey": null
                                  },
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "HasOwnerPermissionsInterface",
                    "abstractKey": "__isHasOwnerPermissionsInterface"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "type": "HasOwnerPermissionsInterface",
            "abstractKey": "__isHasOwnerPermissionsInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Member",
                "kind": "LinkedField",
                "name": "members",
                "plural": true,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Thumbnail",
                "kind": "LinkedField",
                "name": "thumbnail",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VaultManagementGroup",
                "kind": "LinkedField",
                "name": "vaultManagementGroup",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberConnection",
                    "kind": "LinkedField",
                    "name": "managers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v12/*: any*/),
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Vault",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e8bc97142977c8b337c5a537ccb42b7c",
    "id": null,
    "metadata": {},
    "name": "AccessModal_Query",
    "operationKind": "query",
    "text": "query AccessModal_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    id\n    ...PermissionRules_node\n    ...useNodeSecurity_node\n    ... on VaultItem {\n      __typename\n      ...VaultItemAccessDetails_node\n    }\n    ... on HasOwnerPermissionsInterface {\n      __isHasOwnerPermissionsInterface: __typename\n      __typename\n      ...SpaceItemAccessDetails_node\n    }\n    ... on Vault {\n      __typename\n      name\n      members {\n        id\n        ...UserAvatar_member\n      }\n      ...VaultAvatar_vault\n      ...VaultAccessDetails_node\n    }\n    ... on HasAuditLogInterface {\n      __isHasAuditLogInterface: __typename\n      hasAuditLog: __typename\n    }\n  }\n}\n\nfragment EventPermissionRules_event on Event {\n  id\n  canUpdate {\n    value\n  }\n  ownershipSpace {\n    id\n  }\n  permissionConfig {\n    canCreateFolderInRoot {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar {\n              name\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n    canCreateItemInRoot {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar {\n              name\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment FolderPermissionRules_folder on Folder {\n  id\n  canModifyOwners {\n    value\n  }\n  ownershipSpace {\n    id\n  }\n  folderPermissions: permissionConfig {\n    canCreateFolderIn {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar {\n              name\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n    canCreateItemIn {\n      allowedRoles\n      allowedMembers {\n        edges {\n          node {\n            id\n            name\n            avatar {\n              name\n              url\n            }\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment Owner_ownership on Ownership {\n  member {\n    id\n    name\n    ...UserHandle_member\n  }\n  ownerOf {\n    edges {\n      node {\n        __typename\n        ... on Space {\n          name\n        }\n        ... on Event {\n          name\n        }\n        ... on Folder {\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment PermissionRules_node on Node {\n  __isNode: __typename\n  ... on Event {\n    isEvent: __typename\n    ...EventPermissionRules_event\n  }\n  ... on Folder {\n    isFolder: __typename\n    ...FolderPermissionRules_folder\n  }\n  ...useNodeSecurity_node\n}\n\nfragment SpaceItemAccessDetails_node on Node {\n  __isNode: __typename\n  id\n  __typename\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    canModifyOwners {\n      value\n    }\n    ownerships {\n      edges {\n        node {\n          ...Owner_ownership\n          explicitOwner\n          member {\n            id\n            status {\n              __typename\n              value\n            }\n          }\n          ownerOf {\n            edges {\n              node {\n                __typename\n                ... on Node {\n                  __isNode: __typename\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    ownershipPath {\n      edges {\n        node {\n          __typename\n          ... on Space {\n            id\n            name\n            icon {\n              __typename\n              ... on NamedIcon {\n                name\n              }\n            }\n            color {\n              light\n              dark\n            }\n          }\n          ... on Event {\n            id\n            name\n          }\n          ... on Folder {\n            id\n            name\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n\nfragment VaultAccessDetails_node on Vault {\n  id\n  canUpdate {\n    value\n  }\n  name\n  members {\n    id\n    name\n    ...UserHandle_member\n  }\n  vaultManagementGroup {\n    id\n    name\n    ...VaultManagementGroupLabel_vaultManagementGroup\n  }\n}\n\nfragment VaultAvatar_vault on Vault {\n  id\n  name\n  members {\n    id\n    ...UserAvatar_member\n  }\n  thumbnail {\n    url\n  }\n}\n\nfragment VaultItemAccessDetails_node on VaultItem {\n  id\n  uploadGroup {\n    publisher {\n      id\n      ...UserHandle_member\n    }\n    publishedAt {\n      utcDate\n      utcTime\n    }\n    id\n  }\n}\n\nfragment VaultManagementGroupLabel_vaultManagementGroup on VaultManagementGroup {\n  id\n  name\n  managers {\n    edges {\n      node {\n        id\n        ...UserAvatar_member\n      }\n    }\n  }\n}\n\nfragment useNodeSecurity_node on Node {\n  __isNode: __typename\n  id\n  ... on HasNodeSecurityInterface {\n    __isHasNodeSecurityInterface: __typename\n    canUpdateSecurity {\n      value\n    }\n    preventDownload\n    hasWatermark\n  }\n  ... on FolderItem {\n    folderItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    vaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultDraftItem {\n    draftVaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5724fd237e2f29428363c486b0a59998";

export default node;
